<script>
    import { Tooltip } from 'sveltestrap';

    export let id;
    export let isActive;
    export let isDisabled = false;
    export let classes = "";
    export let icon = undefined;
    export let iconSize = undefined;
    export let alertIcon = undefined;
    export let title = undefined;
</script>

<style>
    .btn-icon, .btn-img {
        padding: 0;
        height: 33px;
        width: 38px;
    }
    
    .btn-icon {
        font-size: 16px;
    }

    .btn-icon.btn-icon-lg {
        font-size: 23px;
    }

    .btn-icon .bi-stacked i:first-of-type {
        top: -1px;
    }

    .btn-icon.btn-icon-lg .bi-stacked i:first-of-type {
        top: -3px;
    }

    .btn-icon .bi-stacked .bi-alert {
        color: inherit;
        left: 10px;
        font-size: 0.7em;
    }
</style>

<button {id} type="button" on:click class="btn {classes}" disabled={isDisabled}
        class:btn-icon={icon}
        class:btn-icon-lg={iconSize && iconSize === 'lg'}
        class:btn-primary={isActive}
        class:btn-outline-primary={!isActive}>
    {#if icon}
    <span class="bi-stacked">
        <i class="bi bi-{icon}" />
        {#if alertIcon}
            <i class="bi bi-{alertIcon}-fill bi-alert" />
        {/if}
    </span>
    {/if}
    <slot></slot>
</button>
{#if title}
    <Tooltip target={id} placement="bottom">
        {title}
    </Tooltip>
{/if}